<template>
    <div v-if="json">
        <div class="panel panel-primary">
            <div class="panel-heading"><h4>{{ json.name }}</h4></div>
            <div class="panel-body">
            <resourceTemplate :resource="template" :componentData="componentData" ref="content"></resourceTemplate>
            <schedulerPicker :json="json" ref="schedulerPicker"></schedulerPicker>
            </div>
            <div class="panel-footer">
                Dependencies: <span class="label label-primary dependency" v-for="d in json.dependencies">{{ d }}</span>
            </div>
        </div>
    </div>
    
    <div v-else-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</template>

<script>

import resourceTemplate from '../utils/ResourceTemplate';
import schedulerPicker from 'components/tutorialPicker/schedulerPicker';

export default {
  name: 'tutorialDetails',
  props: ["name", "helper"],
  data () {
    return {
        json: null,
        template: null,
        componentData: null,
        errorMessage: null
    }
  },
  mounted() {
    this.loadDetails();
  },
  components: {
    resourceTemplate,
    schedulerPicker
  },
  methods: {
      loadDetails() {
          if (this.name) {
            var self = this;
            this.json = null;
            this.template = null;
            this.componentData = null;
            self.errorMessage = null;
            this.helper.loadTutorialIndex(this.name, function(json) {
                if (json && json.intro) {
                    self.json = json;
                    self.helper.loadTutorialIntro(self.name, json.intro, function(template, js) {
                        if (js && js.data) {
                            let constrollerConstructor = eval(js.data);
                            self.controller = new constrollerConstructor(self.$refs.content.$el);
                            self.componentData = self.controller.getData;
                        }
                        self.template = template;
                    });
                } else {
                    self.errorMessage = "Cannot load index file for tutorial " + self.name;
                }
            });
          }
      },
      getOptions() {
          var options = {};
          if (this.controller && this.controller.getOptions) {
            options = this.controller.getOptions();
          }
          options.schedulerType = this.$refs.schedulerPicker.getScheduler();
          if (!options.schedulerType) {
              options.schedulerType = "roundrobin";
          } 
          return options;
      }
  },
  watch: {
      name() {
          this.loadDetails();
      }
  }
}
</script>

<style scoped>
    span.dependency {
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// TutorialDetails.vue?74ee381b